import { z } from 'zod';
import { TherapySessionSchema } from './TherapySession';
import { createDateTimeSchema } from './common';
import { PatientSchema } from './Patient';
import { PaymentSchema } from './Payment';
import { BE_DATE_TIME_FORMAT } from 'modules/common/constants';

export const TherapyHistorySchema = z
  .object({
    id: z.number(),
    code: z.string(),
    patientId: z.number(),
    picUserId: z.number(),
    picName: z.string(),
    therapyDefinitionId: z.number(),
    name: z.string(),
    groupId: z.number(),
    packagePrice: z.number(),
    diagnosis: z.string(),
    totalPrice: z.number(),
    paymentPlan: z.string(),
    registerReason: z.string(),
    status: z.string(),
    referenceId: z.number(),
    referenceType: z.string(),
    paymentDetailId: z.number(),
    therapySessionList: z.array(TherapySessionSchema),
    patient: PatientSchema,
    createdTime: createDateTimeSchema(BE_DATE_TIME_FORMAT),
    note: z.string(),
    description: z.string(),
    payment: PaymentSchema,
    numberSession: z.number(),
    numberSessionCompleted: z.number(),
    numberSessionInProgress: z.number(),
    numberSessionNotStarted: z.number(),
    type: z.string(),
  })
  .partial();

export type TherapyHistory = z.infer<typeof TherapyHistorySchema>;
